module.exports = __webpack_public_path__ + "../resources/img/@temp_news_photo_01.198f9af2.jpg";